import React from "react";
import Banner from "../../components/banner/Banner";
import "./Consumers.css";
import CategoryProducts from "../../components/CategoryProducts/CategoryProducts";
import Title from "../../components/titles/Title";
import ConsumerBenefit from "./ConsumerBenefit";

const Consumers = () => {
  return (
    <>
      {/* Banner */}
      <Banner
        className="consumer-bg"
        bannerTitle={["Buy Organic and Chemical Preservative free honey"]}
      />
      {/* Products */}
      <CategoryProducts
        categoryId={["GHRAEXbI00"]}
        title="onMarketplace"
        description="Services not found"
      />
      {/* Benefits */}
      <div className="section-container benefit-container">
        <div className="container">
          <div className="section-sub-container">
            <Title classname="text-center mb-5" heading="Benefits" />
          </div>
          <ConsumerBenefit />
        </div>
      </div>
    </>
  );
};

export default Consumers;
